module.exports = ".fa-edit, .fa-trash, .fa-check-circle {\n  cursor: pointer; }\n\n.fa.read-only {\n  opacity: 0.4;\n  cursor: not-allowed; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/schemas/components/contact-moments.component.scss
// module id = 574
// module chunks = 1